var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-info-orange",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.368,
    height: 30.368,
    viewBox: "0 0 30.368 30.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_74",
    "data-name": "\\u30D1\\u30B9 74",
    d: "M15.184,30.368A15.184,15.184,0,1,0,0,15.184,15.184,15.184,0,0,0,15.184,30.368ZM16.95,12.5l-4.346.545-.155.721.854.158c.558.133.668.334.547.89l-1.4,6.582c-.368,1.7.2,2.5,1.534,2.5a3.931,3.931,0,0,0,2.78-1.135l.167-.79a2.1,2.1,0,0,1-1.3.466c-.522,0-.712-.366-.577-1.011Zm-1.766-2.065a1.9,1.9,0,1,0-1.9-1.9A1.9,1.9,0,0,0,15.184,10.439Z",
    fill: "#f39628",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoOrange);
export default __webpack_public_path__ + "static/media/icon-info-orange.9eb06d25020c694bcb3870704b75c0de.svg";
export { ForwardRef as ReactComponent };